import { render, staticRenderFns } from "./spare-part-table-list.vue?vue&type=template&id=3335487a&"
import script from "./spare-part-table-list.vue?vue&type=script&lang=js&"
export * from "./spare-part-table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports